/**
 * @file 资产管理
 * @author gaoxunchen
 */

import _ from 'lodash';
import React from 'react';

import HomeItem from '../home-item';

import './index.scoped.less';

const CardAssets: React.FC = () => {
  return (
    <HomeItem
      style={{ padding: 0, background: 'none', border: 'unset', borderRadius: 0 }}
    >
      <div className="card-assets">
        <img src="https://agency-static-1258344696.file.myqcloud.com/fe/img/home-card-assets.png" />
      </div>
    </HomeItem>
  );
};

export default CardAssets;
